<template>
  <b-modal
    id="add-or-update"
    :visible="isAddOrUpdateActive"
    centered
    hide-footer
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    size="lg"
    @hidden="resetForm" 
    @hide="resetForm"
    @change="(val) => $emit('update:is-add-or-update-active', val)"
  >
    <template #default="{ hide }">
      <b-overlay :show="loading" class="px-2">
        <div class="d-flex justify-content-between align-items-center content-sidebar-header py-1" style="border-bottom: 1px solid #000000;">
          <h5 class="mb-0" style="font-weight: 400; font-size: 14px; line-height: 160%;">
            Update Member Profile
          </h5>

          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <validation-observer #default="{ handleSubmit }" ref="update_modal_form">
          <b-form class="my-1" @submit.prevent="handleSubmit(onCreateOrUpdate)">
            <b-alert v-if="errorMessage" variant="danger" :show="true">
              <div class="alert-body font-small-2">
                <b-card-text class="mb-0">
                  {{ errorMessage }}
                </b-card-text>
              </div>
            </b-alert>

            <b-tabs v-model="tabIndex">
              <b-tab title="Personal">
                <b-row class="mt-2">
                  <b-col cols="12" md="12">
                    <div class="mb-2 text-center">
                      <b-media class="text-center">
                        <b-avatar ref="previewEl" badge-variant="transparent" :src="avatarPath" :text="avatarText(`${new_data.first_name} ${new_data.last_name}`)" :variant="`light-primary`" size="10rem">
                          <template #badge>
                            <b-button variant="primary" class="btn-icon rounded-circle" @click="$refs.avatar.$el.childNodes[0].click()">
                              <feather-icon icon="CameraIcon" />
                            </b-button>
                          </template>
                        </b-avatar>
                      </b-media>
        
                      <div>
                        <b-form-file v-show="false" ref="avatar" accept="image/*" placeholder="" no-drop @input="onImageRenderer" />
                      </div>
                    </div>
                  </b-col>
                </b-row>
                
                <b-row class="mt-1">
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="First Name" rules="required">
                      <b-form-group label="First Name" label-for="first_name">
                        <template #label>
                          <span>First Name<sup style="color: tomato">*</sup></span>
                        </template>
        
                        <b-form-input 
                          id="first_name" 
                          v-model="new_data.first_name" 
                          placeholder="John"
                          :disabled="disableForm"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
    
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Last Name" rules="required">
                      <b-form-group label="Last Name" label-for="last_name">
                        <template #label>
                          <span>Last Name<sup style="color: tomato">*</sup></span>
                        </template>
        
                        <b-form-input 
                          id="last_name" 
                          v-model="new_data.last_name" 
                          placeholder="Doe"
                          :disabled="disableForm"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
    
                <b-row class="mt-1">
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Date of Birth" rules="required">
                      <b-form-group label="Date of Birth" label-for="last_name">
                        <template #label>
                          <span>Date of Birth<sup style="color: tomato">*</sup></span>
                        </template>
        
                        <cleave 
                          v-model="new_data.date_of_birth"
                          :raw="false"
                          :options="cleaveDateOptions"
                          autocomplete="off"
                          class="form-control"
                          name="date of birth"
                          placeholder="YYYY-MM-DD"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
    
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Gender" rules="required">
                      <b-form-group label="Gender" label-for="gender">
                        <template #label>
                          <span>Gender<sup style="color: tomato">*</sup></span>
                        </template>
        
                        <v-select
                          id="gender"
                          placeholder="Gender"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :value="new_data.gender"
                          :options="genderOptions"
                          :reduce="val => val.value"
                          :disabled="loading"
                          @input="(val) => new_data.gender = val"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
    
                <b-row class="mt-1">
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Country" rules="required">
                      <b-form-group label="Country" label-for="country">
                        <template #label>
                          <span>Country<sup style="color: tomato">*</sup></span>
                        </template>
        
                        <v-select
                          class="country"
                          placeholder="Country"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :value="new_data.country"
                          :options="countryOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          :disabled="loading"
                          @input="(val) => new_data.country = val"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Wife" rules="">
                      <b-form-group label="Wife" label-for="wife">
                        <template #label>
                          <span>Wife</span>
                        </template>
        
                        <b-form-input 
                          id="wife" 
                          v-model="new_data.wife" 
                          placeholder="Wife"
                          :disabled="disableForm"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row class="mt-1">
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Hometown" rules="">
                      <b-form-group label="Hometown" label-for="hometown">
                        <template #label>
                          <span>Hometown</span>
                        </template>
        
                        <b-form-input 
                          id="hometown" 
                          v-model="new_data.home_town" 
                          placeholder="Hometown"
                          :disabled="disableForm"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
    
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Profession" rules="">
                      <b-form-group label="Profession" label-for="profession">
                        <template #label>
                          <span>Profession</span>
                        </template>
        
                        <b-form-input 
                          id="profession" 
                          v-model="new_data.profession" 
                          placeholder="Profession"
                          :disabled="disableForm"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row class="mt-1">
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Languages Spoken" rules="">
                      <b-form-group label="Languages Spoken" label-for="languages_spoken">
                        <template #label>
                          <span>Languages Spoken</span>
                        </template>
        
                        <b-form-input 
                          id="languages_spoken" 
                          v-model="new_data.languages_spoken" 
                          placeholder="Languages spoken"
                          :disabled="disableForm"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Qualifications" rules="">
                      <b-form-group label="Qualifications" label-for="qualifications">
                        <template #label>
                          <span>Qualifications</span>
                        </template>
        
                        <b-form-textarea 
                          id="qualifications" 
                          v-model="new_data.qualifications" 
                          placeholder="Qualifications"
                          rows="3"
                          :disabled="disableForm"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-button 
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2" 
                  @click="tabIndex++"
                >
                  Next
                </b-button>
              </b-tab>
    
              <b-tab title="Ministry">
                <b-row class="mt-1">
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Member Type" rules="required">
                      <b-form-group label="Member Type" label-for="member_type">
                        <template #label>
                          <span>Member Type<sup style="color: tomato">*</sup></span>
                        </template>
        
                        <v-select
                          id="member_type"
                          placeholder="Member type"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :value="new_data.member_type_id"
                          :options="member_types"
                          :reduce="val => val.value"
                          :disabled="loading"
                          @input="(val) => new_data.member_type_id = val"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>

                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Member Title" rules="required">
                      <b-form-group label="Member Title" label-for="member_title">
                        <template #label>
                          <span>Member Title<sup style="color: tomato">*</sup></span>
                        </template>
        
                        <v-select
                          class="member_title"
                          placeholder="Member Title"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :value="new_data.member_title_id"
                          :options="memberTitleOptions"
                          :reduce="val => val.value"
                          :disabled="loading"
                          @input="(val) => new_data.member_title_id = val"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row class="mt-1">
                  <b-col cols="12" md="6">
                    <b-form-group label="Member Designation" label-for="member_designation">
                      <template #label>
                        <span>Member Designation<sup style="color: tomato">*</sup></span>
                      </template>
      
                      <validation-provider #default="{ errors }" name="Member Designation" rules="required">
                        <v-select
                          v-model="new_data.member_designation_id"
                          class=""
                          placeholder="Member Designation"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="memberDesignationOptions"
                          :reduce="val => val.value"
                          :disabled="loading"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group label="Department" label-for="department">
                      <template #label>
                        <span>Department</span>
                      </template>
    
                      <validation-provider #default="{ errors }" name="Department">
                        <v-select
                          v-model="new_data.department_id"
                          class=""
                          placeholder="Department"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="departmentOptions"
                          :reduce="val => val.value"
                          :disabled="loading"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
    
                <div v-if="new_data.country === 'Ghana'">
                  <b-row class="mt-1">
                    <b-col cols="12" md="6">
                      <b-form-group label="Region" label-for="region">
                        <template #label>
                          <span>Region<sup style="color: tomato">*</sup></span>
                        </template>
                        
                        <validation-provider #default="{ errors }" name="Region" rules="required">
                          <v-select
                            id="region"
                            v-model="new_data.region"
                            placeholder="Region"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="regionOptions"
                            :reduce="val => val.value"
                            :disabled="loading"
                            @input="(val) => new_data.region = val"
                          />
                          
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
      
                    <b-col cols="12" md="6">
                      <b-form-group label="Area" label-for="area">
                        <template #label>
                          <span>Area<sup style="color: tomato">*</sup></span>
                        </template>
    
                        <validation-provider #default="{ errors }" name="Area" rules="required">
                          <v-select
                            id="area"
                            v-model="new_data.area"
                            placeholder="Area"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="areaOptions"
                            :reduce="val => val.value"
                            :disabled="loading"
                            @input="(val) => new_data.area = val"
                          />
                          
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
      
                  <b-row class="mt-1">
                    <b-col cols="12" md="6">
                      <b-form-group label="District" label-for="district">
                        <template #label>
                          <span>District<sup style="color: tomato">*</sup></span>
                        </template>
    
                        <validation-provider #default="{ errors }" name="District" rules="required">
                          <v-select
                            id="district"
                            v-model="new_data.district"
                            placeholder="District"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="districtOptions"
                            :reduce="val => val.value"
                            :disabled="loading"
                            @input="(val) => new_data.district = val"
                          />
                          
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
      
                    <b-col cols="12" md="6">
                      <b-form-group label="Assembly" label-for="assembly">
                        <template #label>
                          <span>Assembly<sup style="color: tomato">*</sup></span>
                        </template>
                        
                        <validation-provider #default="{ errors }" name="Assembly" rules="required">
                          <v-select
                            id="assembly"
                            v-model="new_data.assembly"
                            placeholder="Assembly"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="assemblyOptions"
                            :reduce="val => val.value"
                            :disabled="loading"
                            @input="(val) => new_data.assembly = val"
                          />
                          
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
    
                <div v-else>
                  <b-row class="mt-1">
                    <b-col cols="12" md="6">
                      <validation-provider #default="{ errors }" name="Region" rules="required">
                        <b-form-group label="Region" label-for="region">
                          <template #label>
                            <span>Region<sup style="color: tomato">*</sup></span>
                          </template>
          
                          <b-form-input 
                            id="region" 
                            v-model="new_data.region" 
                            placeholder="Region"
                            :disabled="disableForm"
                          />
                          
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
    
                    <b-col cols="12" md="6">
                      <b-form-group label="Area" label-for="area">
                        <template #label>
                          <span>Area<sup style="color: tomato">*</sup></span>
                        </template>
    
                        <validation-provider #default="{ errors }" name="Area" rules="required">
                          <b-form-input 
                            id="area" 
                            v-model="new_data.area" 
                            placeholder="Area"
                            :disabled="disableForm"
                          />
                          
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
    
                  <b-row class="mt-1">
                    <b-col cols="12" md="6">
                      <b-form-group label="District" label-for="district">
                        <template #label>
                          <span>District<sup style="color: tomato">*</sup></span>
                        </template>
    
                        <validation-provider #default="{ errors }" name="District" rules="required">
                          <b-form-input 
                            id="district" 
                            v-model="new_data.district" 
                            placeholder="District"
                            :disabled="disableForm"
                          />
                          
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
    
                    <b-col cols="12" md="6">
                      <b-form-group label="Assembly" label-for="assembly">
                        <template #label>
                          <span>Assembly<sup style="color: tomato">*</sup></span>
                        </template>
    
                        <validation-provider #default="{ errors }" name="Assembly" rules="required">
                          <b-form-input 
                            id="assembly" 
                            v-model="new_data.assembly" 
                            placeholder="Assembly"
                            :disabled="disableForm"
                          />
                          
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
    
                <div v-if="isCopMinister">
                  <b-row class="mt-1">
                    <b-col cols="12" md="6">
                      <validation-provider #default="{ errors }" name="Minister Id" rules="required">
                        <b-form-group label="Minister Id" label-for="minister_id">
                          <template #label>
                            <span>Minister Id<sup style="color: tomato">*</sup></span>
                          </template>
          
                          <b-form-input 
                            id="minister_id" 
                            v-model="new_data.minister_id" 
                            placeholder="Minister Id"
                            :disabled="disableForm"
                          />
                          
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
    
                    <b-col cols="12" md="6">
                      <validation-provider #default="{ errors }" name="Year Called Into Ministry" rules="required">
                        <b-form-group label="Year Called Into Ministry" label-for="area">
                          <template #label>
                            <span>Year Called Into Ministry<sup style="color: tomato">*</sup></span>
                          </template>
          
                          <b-form-input 
                            id="year_called_into_ministry" 
                            v-model="new_data.year_called_into_ministry" 
                            placeholder="Year called into ministry"
                            :disabled="disableForm"
                          />
                          
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </div>

                <b-row class="mt-1">
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Called From" rules="">
                      <b-form-group label="Called From" label-for="called_from">
                        <template #label>
                          <span>Called From</span>
                        </template>
        
                        <b-form-input 
                          id="called_from" 
                          v-model="new_data.called_from" 
                          placeholder="Called from"
                          :disabled="disableForm"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
    
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Years in Current Area" rules="">
                      <b-form-group label="Years in Current Area" label-for="years_in_current_area">
                        <template #label>
                          <span>Years in Current Area</span>
                        </template>
        
                        <b-form-input 
                          id="years_in_current_area" 
                          v-model="new_data.years_in_current_area" 
                          placeholder="Years in current area"
                          type="number"
                          :disabled="disableForm"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-row class="mt-1">    
                  <b-col cols="12" md="6">
                    <validation-provider #default="{ errors }" name="Years in Current Station" rules="">
                      <b-form-group label="Years in Current Station" label-for="years_in_current_station">
                        <template #label>
                          <span>Years in Current Station</span>
                        </template>
        
                        <b-form-input 
                          id="years_in_current_station" 
                          v-model="new_data.years_in_current_station" 
                          placeholder="Years in current station"
                          type="number"
                          :disabled="disableForm"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>

                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2 mt-2" 
                  @click="tabIndex--"
                >
                  Previous
                </b-button>

                <b-button 
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2 mt-2" 
                  @click="tabIndex++"
                >
                  Next
                </b-button>
              </b-tab>

              <b-tab title="Stations">
                <b-col cols="12" md="12">
                  <validation-provider #default="{ errors }" name="Stations Served" rules="">
                    <b-form-group label="Stations Served" label-for="stations">
                      <template #label>
                        <span>Stations Served (Title, Year)</span>
                      </template>
      
                      <div v-for="(station, index) in new_data.stations" :key="index">
                        <b-row>
                          <b-col cols="12" md="6">
                            <b-form-input 
                              v-model="station.title"
                              class="mt-1"
                              placeholder="Title"
                            />
                          </b-col>
  
                          <b-col cols="12" md="6" class="d-flex align-items-center">
                            <b-form-input 
                              v-model="station.year"
                              class="mt-1"
                              placeholder="Year"
                            />


                            <b-button
                              variant="no-outline"
                              type="button"
                              @click="onRemoveStation(index)"
                            >
                              <feather-icon icon="TrashIcon" size="20" color="red" />
                            </b-button>
                          </b-col>
                        </b-row>
                      </div>

                      <div>              
                        <b-button
                          variant="outline-primary"
                          type="button"
                          class="mt-2" 
                          @click="onAddStation"
                        >
                          Add Station
                        </b-button>
                      </div>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Form Actions -->
                <b-col class="d-flex mt-3">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2" 
                    @click="tabIndex--"
                  >
                    Previous
                  </b-button>

                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2"
                    type="submit"
                    :disabled="disableForm"
                  >
                    {{ isUpdate ? 'Update' : 'Add' }}
                  </b-button>

                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    type="button"
                    variant="outline-secondary"
                    @click="hide"
                  >
                    Cancel
                  </b-button>
                </b-col>
              </b-tab>
            </b-tabs>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template>
  </b-modal>
</template>
  
<script>
import {
  BOverlay, BSidebar, BForm, BFormGroup, BFormInput, BRow, BCol, BAvatar,
  BFormTextarea, BFormInvalidFeedback, BButton, BFormFile, BFormCheckbox,
  BAlert, BCardText, BModal, BMedia, BMediaBody, BMediaAside, BImg,
  BTabs, BTab,
} from 'bootstrap-vue'

import { required } from '@validations'
import { get, cloneDeep } from 'lodash';
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const rawData = {
  gender: "",
  first_name: "",
  last_name: "",
  date_of_birth: "",
  year_called_into_ministry: "",

  minister_id: "",
  department_id: "",
  member_type_id: "",
  member_title_id: "",
  member_designation_id: "",

  country: "Ghana",
  region: "",
  area: "",
  district: "",
  assembly: "",
  home_town: "",
  profession: "",
  called_from: "",
  qualifications: "",
  languages_spoken: "",
  years_in_current_area: 0,
  wife: "",

  stations: [
    {
      title: "",
      year: ""   
    },
  ],
  years_in_current_station: 0,
  
  member_type: {},
}

const rawBioData = {
  stations: [
    {
      title: "",
      year: ""   
    },
  ],
}

const memberTitlesAndDesignationCachedData = []
  
export default {
  components: {
    BImg,
    BRow,
    BCol,
    BTab,
    BTabs,
    BForm,
    BAlert,
    BModal,
    BMedia, 
    BButton,
    Cleave,
    vSelect,
    BAvatar,
    BOverlay,
    BSidebar,
    BCardText,
    BFormFile,
    BFormGroup,
    BMediaBody, 
    BFormInput,
    BMediaAside,
    BFormCheckbox,
    BFormTextarea,
    BFormInvalidFeedback,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddOrUpdateActive',
    event: 'update:is-add-or-update-active',
  },
  props: {
    isAddOrUpdateActive: {
      type: Boolean,
      required: true,
    },
    updateData: {
      type: Object,
      default: null,
      required: false
    },

  },
  data() {
    return {
      new_data: cloneDeep(rawData),
      bio_data: cloneDeep(rawBioData),
      loading: false,
      errorMessage: "",

      tabIndex: 0,
      member_types: [],
      memberTitleOptions: [],
      memberDesignationOptions: [],

      genderOptions: [
        {
          value: "female",
          label: "Female",
        },
        {
          value: "male",
          label: "Male",
        },
      ],

      temp_area: "",
      temp_region: "",
      temp_district: "",
      temp_member_types: "",
      temp_member_type_id: "",

      avatarPath: "",
      avatarImage: "",
      departmentOptions: [],
      regionOptions: [],
      areaOptions: [],
      districtOptions: [],
      assemblyOptions: [],
      countryOptions: [],

      cleaveDateOptions: {
        date: true,
        raw: true,
        delimiter: '-',
        datePattern: ['Y', 'm', 'd'],
        blocks: [4, 2, 2],
      },

      required,
    }
  },
  computed: {
    isUpdate(){
      return !!this.updateData
    },
    disableForm(){
      if (this.isUpdate){
        return !this.can("member_profiles:CanUpdate")
      }

      return !this.can("member_profiles:CanAddNew")
    },
    isCopMinister() {
      const selected_member_type = this.member_types.find(
        (member_type) => member_type.value === this.new_data.member_type_id
      );
      
      return selected_member_type ? selected_member_type.is_cop_minister : false;
    }
  },
  watch: {
    updateData: {
      handler(updateData){
        if (updateData){
          this.new_data = {
            _id: updateData._id,
            area: updateData.area,
            region: updateData.region,
            gender: updateData.gender,
            country: updateData.country,
            district: updateData.district,
            assembly: updateData.assembly,
            last_name: updateData.last_name,
            first_name: updateData.first_name,
            minister_id: updateData.minister_id,
            member_type: updateData.member_type,
            department_id: updateData.department_id,
            date_of_birth: updateData.date_of_birth,
            member_type_id: updateData.member_type_id,
            member_title_id: updateData.member_title_id,
            member_designation_id: updateData.member_designation_id,
            year_called_into_ministry: updateData.year_called_into_ministry,
            // New
            wife: updateData.wife,
            stations: updateData.stations,
            home_town: updateData.home_town,
            profession: updateData.profession,
            qualifications: updateData.qualifications,
            called_from: updateData.called_from,
            languages_spoken: updateData.languages_spoken,
            years_in_current_area: updateData.years_in_current_area,
            years_in_current_station: updateData.years_in_current_station,
          },
          this.avatarPath = updateData.avatar.path
          this.temp_member_type_id = updateData.member_type_id
          this.temp_area = updateData.area
          this.temp_region = updateData.region
          this.temp_district = updateData.district
          this.temp_member_types = updateData.member_type
        }
      },
      immediate: true,
      deep: true
    },
    "new_data.member_type_id": {
      handler(member_type_id) {
        if (member_type_id) {
          if (member_type_id !== this.temp_member_type_id){
            this.new_data.member_title_id = "";
            this.new_data.member_designation_id = "";
          }

          const existingTitleAndDesignationIndex = memberTitlesAndDesignationCachedData.findIndex(i => i.id === this.new_data.member_type_id);

          if (existingTitleAndDesignationIndex >= 0) {
            this.memberTitleOptions = memberTitlesAndDesignationCachedData[existingTitleAndDesignationIndex].titles;
            this.memberDesignationOptions = memberTitlesAndDesignationCachedData[existingTitleAndDesignationIndex].designations;

            return;
          }

          this.fetchMemberTitlesAndDesignations(member_type_id);
        }
      },
      immediate: true
    },
    "new_data.region": {
      handler(changed) {
        if (changed) {
          if (changed !== this.temp_region){
            this.new_data.area = "";
            this.new_data.district = "";
            this.new_data.assembly = "";
          }
          if (this.new_data.country !== "Ghana") {
            return;
          }
          this.fetchChurchAreas();
        }
      },
      immediate: true,
    },
    "new_data.area": {
      handler(changed) {
        if (changed) {
          if (changed !== this.temp_area){
            this.new_data.district = "";
            this.new_data.assembly = "";
          }
          if (this.new_data.country !== "Ghana") {
            return;
          }
          this.fetchChurchDistrict();
        }
      },
      immediate: true,
    },
    "new_data.district": {
      handler(changed) {
        if (changed) {
          if (changed !== this.temp_district){
            this.new_data.assembly = "";
          }
          if (this.new_data.country !== "Ghana") {
            return;
          }
          this.fetchChurchAssemblies();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.fetchCountries();
    this.fetchMemberTypes();
    this.fetchDepartments();
    this.fetchChurchRegions();
  },
  methods: {
    async onCreateOrUpdate(){
      try {
        this.loading = true;
        this.errorMessage = "";

        const success = await this.$refs.update_modal_form.validate();
        if (!success){
          return;
        }

        const messages = {
          update: {
            title: "Confirm Member Update",
            text: "Do you want to update this member?",
            icon: "warning"
          },
        }

        /* eslint-disable no-nested-ternary */
        const message = messages.update 
        const { title, text, icon } = message;

        const result = await this.$swal({
          title,
          text,
          icon,
          showCancelButton: true,
          confirmButtonText: 'Yes, proceed.',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });
        if (!result.isConfirmed) {
          return;
        }

        const id = this.new_data._id

        if (!this.can("member_profiles:CanUpdate")) {
          return
        }

        const {
          first_name, 
          last_name, 
          date_of_birth, 
          gender,
          area,
          region,
          country,
          district,
          assembly,
          minister_id,
          department_id,
          member_type_id,
          member_title_id,
          member_designation_id,
          year_called_into_ministry,

          wife,
          stations,
          home_town,
          profession,
          qualifications,
          called_from,
          languages_spoken,
          years_in_current_area,
          years_in_current_station,
        } = this.new_data

        const filtered_stations = stations.map((el) => ({
          title: el.title,
          year: el.year
        }));

        const payload = {
        first_name, 
        last_name, 
        date_of_birth, 
        gender,
        area,
        region,
        country,
        district,
        assembly,
        minister_id,
        department_id,
        member_type_id,
        member_title_id,
        member_designation_id,
        year_called_into_ministry,

        wife,
        home_town,
        profession,
        qualifications,
        called_from,
        languages_spoken,
        years_in_current_area,
        years_in_current_station,
        stations: filtered_stations,
      }

        await this.useJwt().mainService.memberProfiles.update(id, payload);

        this.$emit("refetchData");
        this.$emit('update:is-add-or-update-active', false);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'AlertQuestionIcon',
            variant: 'success',
            text: `Member updated successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    async fetchMemberTypes() {
      try {
        this.loading = true;

        const query = {
          limit: 1000,
        }

        const request = await this.useJwt().mainService.memberTypes.list(query);
        const { data } = request.data;

        this.member_types = data.map((member_type) => ({
          label: member_type.title,
          value: member_type._id,
          is_cop_minister: member_type.is_cop_minister
        }));        

        this.new_data.member_type_id = "";
        this.new_data.member_title_id = "";
        this.new_data.member_designation_id = "";
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberTitlesAndDesignations(member_type_id) {
      try {
        const query = {
          member_type_id
        }
        const member_title_resp = await this.useJwt().mainService.memberTitles.list(query);
        const member_designation_rep = await this.useJwt().mainService.memberDesignations.list(query);
        const member_titles = get(member_title_resp.data, 'data.[0].categories')
        const member_designations = get(member_designation_rep.data, 'data.[0].categories')

        this.memberTitleOptions = member_titles.map((member_title) => ({
          label: member_title.title,
          value: member_title._id,
        }));

        this.memberDesignationOptions = member_designations.map((member_designation) => ({
          label: member_designation.designation,
          value: member_designation._id,
        }));

        memberTitlesAndDesignationCachedData.push({ 
          id: this.new_data.member_type_id, 
          titles: this.memberTitleOptions, 
          designations: this.memberDesignationOptions 
        })
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
          console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async fetchDepartments() {
      try {
        const response = await this.useJwt().sharedService.fetchDepartments();

        const departments = get(response, "data");
        
        this.departmentOptions = departments.map((department) => ({
          value: department._id,
          label: department.title,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async fetchChurchRegions() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchChurchRegions();
        const { data } = request.data;
        this.regionOptions = data.map((opt) => ({
          label: opt.name,
          value: opt.name,
        }));
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAreas() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchChurchAreas(
          this.new_data.region
        );
        const { data } = request.data;
        this.areaOptions = data.map((opt) => ({
          label: opt.name,
          value: opt.name,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchDistrict() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchChurchDistricts(
          this.new_data.region,
          this.new_data.area
        );
        const { data } = request.data;
        this.districtOptions = data.map((opt) => ({
          label: opt.name,
          value: opt.name,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAssemblies() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchChurchAssemblies(
          this.new_data.region,
          this.new_data.area,
          this.new_data.district
        );
        const { data } = request.data;
        this.assemblyOptions = data.map((opt) => ({
          label: opt.name,
          value: opt.name,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchCountries() {
      try {
        const response = await this.useJwt().sharedService.fetchCountries();

        const countries = get(response, "data.data");
        this.countryOptions = countries.map((country) => ({
          label: country.country,
          value: country.country,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async onCreateOrUpdateAvatar(){
      try {
        this.loading = true;
        this.errorMessage = "";

        const id = this.new_data._id

        if (!this.can("member_profiles:CanUpdate")) {
          return
        }

        const formData = new FormData();

        if (this.avatarImage) {
          formData.append("avatar", this.avatarImage);
        }

        await this.useJwt().mainService.memberProfiles.updateAvatar(id, formData);

        if (this.avatarImage) {
          this.avatarImage = null;
        }
        
        this.$emit("refetchData");
        this.$emit('update:is-add-or-update-active', false);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'AlertQuestionIcon',
            variant: 'success',
            text: `Avatar updated successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    onImageRenderer(file) {
      const reader = new FileReader()

      reader.addEventListener(
        'load',
        () => {
          this.avatarPath = reader.result
          this.avatarImage = file;
          this.onCreateOrUpdateAvatar()
        },
        false,
      )

      if (file) {
        reader.readAsDataURL(file)
      }
    },
    onAddStation(){
      this.new_data.stations.push(cloneDeep(rawBioData));
    },
    onRemoveStation(index) {
      this.new_data.stations.splice(index, 1);
    },
    resetForm() {
      this.$emit("resetUpdateData")
      this.new_data = {};
      this.tabIndex = 0
    }
  }
}
</script>
  
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  
  #add-or-update {
    .vs__dropdown-menu {
      max-height: 200px !important;
    }
  }
</style>
